"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportDownload = void 0;
var react_1 = __importStar(require("react"));
var apiService_1 = __importDefault(require("@common/services/apiService"));
var file_saver_1 = __importDefault(require("file-saver"));
function ReportDownload(_a) {
    var domain = _a.domain, file = _a.file, angularJsDependencies = _a.angularJsDependencies;
    (0, react_1.useEffect)(function () {
        if (file) {
            // exemple of file name 'Implio-d996f6e6-ead6-49d5-bf49-a555574d558d-daily-volume-2022-12-01T23_00Z-2022-12-08T22_59Z-k28fBvLK.csv'
            apiService_1.default.getReport({ domain: domain, fileName: file })
                .then(function (response) {
                file_saver_1.default.saveAs(response.data, file);
            })
                .finally(function () {
                angularJsDependencies.go('app.assignment.overview.statistics');
            });
        }
    }, [file]);
    return react_1.default.createElement(react_1.default.Fragment, null);
}
exports.ReportDownload = ReportDownload;
